import React, { useState } from 'react';

const SensoryAssessment = ({ value = {}, onChange }) => {
  const [open, setOpen] = useState(false);

  const handleChange = (field, val) => {
    onChange({ ...value, [field]: val });
  };

  const sensoryOptions = {
    general: [
      { value: '', label: '-- Select --' },
      { value: 'normal', label: 'Normal' },
      { value: 'intact', label: 'Intact' },
      { value: 'impaired', label: 'Impaired' },
      { value: 'absent', label: 'Absent' },
      { value: 'decreased', label: 'Decreased' },
      { value: 'increased', label: 'Increased' },
      { value: 'hyperesthesia', label: 'Hyperesthesia' },
      { value: 'hypoesthesia', label: 'Hypoesthesia' },
      { value: 'anesthesia', label: 'Anesthesia' },
      { value: 'paresthesia', label: 'Paresthesia' },
      { value: 'dysesthesia', label: 'Dysesthesia' }
    ],
    pain: [
      { value: '', label: '-- Select --' },
      { value: 'normal', label: 'Normal' },
      { value: 'intact', label: 'Intact' },
      { value: 'impaired', label: 'Impaired' },
      { value: 'absent', label: 'Absent' },
      { value: 'hyperalgesia', label: 'Hyperalgesia' },
      { value: 'hypoalgesia', label: 'Hypoalgesia' },
      { value: 'analgesia', label: 'Analgesia' },
      { value: 'allodynia', label: 'Allodynia' }
    ],
    proprioception: [
      { value: '', label: '-- Select --' },
      { value: 'normal', label: 'Normal' },
      { value: 'intact', label: 'Intact' },
      { value: 'impaired', label: 'Impaired' },
      { value: 'absent', label: 'Absent' },
      { value: 'decreased', label: 'Decreased' },
      { value: 'severely_impaired', label: 'Severely Impaired' }
    ],
    cortical: [
      { value: '', label: '-- Select --' },
      { value: 'normal', label: 'Normal' },
      { value: 'intact', label: 'Intact' },
      { value: 'impaired', label: 'Impaired' },
      { value: 'absent', label: 'Absent' },
      { value: 'astereognosis', label: 'Astereognosis' },
      { value: 'agraphesthesia', label: 'Agraphesthesia' },
      { value: 'tactile_agnosia', label: 'Tactile Agnosia' },
      { value: 'extinction', label: 'Extinction' }
    ],
    twoPoint: [
      { value: '', label: '-- Select --' },
      { value: 'normal', label: 'Normal' },
      { value: 'intact', label: 'Intact' },
      { value: 'impaired', label: 'Impaired' },
      { value: 'absent', label: 'Absent' },
      { value: '2mm', label: '2mm' },
      { value: '5mm', label: '5mm' },
      { value: '10mm', label: '10mm' },
      { value: '15mm', label: '15mm' },
      { value: '20mm', label: '20mm' },
      { value: '>20mm', label: '>20mm' }
    ]
  };

  const sensoryRows = [
    { prefix:'sensation', label:'Sensation', options:sensoryOptions.general },
    { prefix:'superficial', label:'Superficial', options:sensoryOptions.general },
    { prefix:'pain', label:'Pain', options:sensoryOptions.pain },
    { prefix:'temperature', label:'Temperature', options:sensoryOptions.general },
    { prefix:'touch', label:'Touch', options:sensoryOptions.general },
    { prefix:'pressure', label:'Pressure', options:sensoryOptions.general },
    { prefix:'deep', label:'Deep', options:sensoryOptions.general },
    { prefix:'movsense', label:'Mov. Sense', options:sensoryOptions.proprioception },
    { prefix:'possense', label:'Pos. Sense', options:sensoryOptions.proprioception },
    { prefix:'vibration', label:'Vibration', options:sensoryOptions.general },
    { prefix:'cortical', label:'Cortical', options:sensoryOptions.cortical },
    { prefix:'tactile', label:'Tactile Localization', options:sensoryOptions.cortical },
    { prefix:'twopoint', label:'2 pt. discrimination', options:sensoryOptions.twoPoint },
    { prefix:'stereognosis', label:'Stereognosis', options:sensoryOptions.cortical },
    { prefix:'barognosis', label:'Barognosis', options:sensoryOptions.cortical },
    { prefix:'graphesthesia', label:'Graphesthesia', options:sensoryOptions.cortical },
    { prefix:'texture', label:'Texture Recognition', options:sensoryOptions.cortical },
    { prefix:'double', label:'Double Simultaneous Stimulation', options:sensoryOptions.cortical }
  ];

  // Count filled entries
  const filledCount = Object.keys(value).filter(k => value[k] && value[k] !== '').length;
  
  // Count abnormal findings (anything not empty, normal, or intact)
  const abnormalCount = Object.keys(value).filter(k => {
    const v = value[k];
    return v && v !== '' && v !== 'normal' && v !== 'intact';
  }).length;

  const tableStyles = {
    table: { width: '100%', borderCollapse: 'collapse', fontSize: '12px', border: '0.5px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden' },
    th: { background: '#f8fafc', padding: '10px 8px', fontWeight: '600', color: '#64748b', fontSize: '11px', border: '0.5px solid #e2e8f0', textAlign: 'center' },
    rowHeader: { background: '#f8fafc', padding: '8px 12px', fontWeight: '600', color: '#374151', fontSize: '12px', borderRight: '0.5px solid #e2e8f0' },
    select: { width: '100%', padding: '6px 8px', fontSize: '11px', border: '1px solid #e2e8f0', borderRadius: '6px', background: '#fff', cursor: 'pointer', color: '#374151' },
    textarea: { width: '100%', padding: '6px 8px', fontSize: '11px', border: '1px solid #e2e8f0', borderRadius: '6px', background: '#fff', minHeight: '50px', resize: 'vertical', fontFamily: 'inherit' }
  };

  return (
    <div style={{ marginBottom: '8px' }}>
      {!open ? (
        <button type="button" onClick={() => setOpen(true)} style={{
          width: '100%', padding: '15px',
          borderRadius: '14px', border: '1px solid #e2e8f0',
          backgroundColor: 'transparent', color: '#d97706',
          fontSize: '0.95rem', fontWeight: '700', cursor: 'pointer',
          display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px',
          transition: 'all 0.2s'
        }}>
          + Sensory System Assessment
          {filledCount > 0 && (
            <span style={{ fontSize: '11px', padding: '2px 10px', borderRadius: '20px', background: '#d97706', color: '#fff', fontWeight: 800 }}>
              {filledCount} entries
            </span>
          )}
          {abnormalCount > 0 && (
            <span style={{ fontSize: '11px', padding: '2px 10px', borderRadius: '20px', background: '#dc2626', color: '#fff', fontWeight: 800 }}>
              {abnormalCount} abnormal
            </span>
          )}
        </button>
      ) : (
        <div style={{ padding: '20px', position: 'relative' }}>
          {/* Header */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
            <div>
              <span style={{ fontWeight: '800', fontSize: '1rem', color: '#d97706' }}>🌡️ Sensory System Assessment</span>
              {abnormalCount > 0 && (
                <span style={{ marginLeft: '12px', fontSize: '11px', padding: '4px 12px', borderRadius: '20px', background: '#fef2f2', color: '#dc2626', border: '1px solid #fca5a5', fontWeight: 700 }}>
                  {abnormalCount} abnormal finding{abnormalCount > 1 ? 's' : ''}
                </span>
              )}
            </div>
            <button type="button" onClick={() => setOpen(false)}
              style={{ background: 'none', border: 'none', color: '#cbd5e1', fontSize: '1.6rem', cursor: 'pointer', lineHeight: 1 }}
              onMouseEnter={e => e.target.style.color = '#ef4444'}
              onMouseLeave={e => e.target.style.color = '#cbd5e1'}>×</button>
          </div>

          {/* Summary */}
          {filledCount > 0 && (
            <div style={{ padding: '12px 16px', borderRadius: '12px', background: '#fff', border: '1px solid #fbbf24', marginBottom: '16px', fontSize: '11px', color: '#92400e' }}>
              <strong>{filledCount}</strong> sensory parameters assessed · <strong>{abnormalCount}</strong> abnormal findings detected
            </div>
          )}

          {/* Table */}
          <div style={{ overflowX: 'auto', borderRadius: '12px' }}>
          <div style={{ background: '#fff', border: '0.5px solid #e2e8f0', minWidth: '560px' }}>
            <table style={tableStyles.table}>
              <thead>
                <tr>
                  <th rowSpan="2" style={tableStyles.th}>Sensory Modality</th>
                  <th colSpan="2" style={tableStyles.th}>Upper Extremity</th>
                  <th colSpan="2" style={tableStyles.th}>Lower Extremity</th>
                  <th colSpan="2" style={tableStyles.th}>Trunk</th>
                  <th rowSpan="2" style={tableStyles.th}>Comments</th>
                </tr>
                <tr>
                  <th style={tableStyles.th}>R</th>
                  <th style={tableStyles.th}>L</th>
                  <th style={tableStyles.th}>R</th>
                  <th style={tableStyles.th}>L</th>
                  <th style={tableStyles.th}>R</th>
                  <th style={tableStyles.th}>L</th>
                </tr>
              </thead>

              <tbody>
                {sensoryRows.map(row => (
                  <tr key={row.prefix} style={{ background: '#fff' }}>
                    <td style={tableStyles.rowHeader}>{row.label}</td>

                    {['ue_rt', 'ue_lt', 'le_rt', 'le_lt', 'trunk_rt', 'trunk_lt'].map(loc => (
                      <td key={loc} style={{ padding: '6px', border: '0.5px solid #f1f5f9' }}>
                        <select
                          style={{
                            ...tableStyles.select,
                            background: value[`${row.prefix}_${loc}`] && value[`${row.prefix}_${loc}`] !== '' && value[`${row.prefix}_${loc}`] !== 'normal' && value[`${row.prefix}_${loc}`] !== 'intact' ? '#fef2f2' : '#fff',
                            borderColor: value[`${row.prefix}_${loc}`] && value[`${row.prefix}_${loc}`] !== '' && value[`${row.prefix}_${loc}`] !== 'normal' && value[`${row.prefix}_${loc}`] !== 'intact' ? '#fca5a5' : '#e2e8f0'
                          }}
                          value={value[`${row.prefix}_${loc}`] || ''}
                          onChange={(e) => handleChange(`${row.prefix}_${loc}`, e.target.value)}
                        >
                          {row.options.map(opt => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                          ))}
                        </select>
                      </td>
                    ))}

                    <td style={{ padding: '6px', border: '0.5px solid #f1f5f9' }}>
                      <textarea
                        style={tableStyles.textarea}
                        value={value[`${row.prefix}_comments`] || ''}
                        onChange={(e) => handleChange(`${row.prefix}_comments`, e.target.value)}
                        placeholder="Notes..."
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          </div>

          {filledCount > 0 && (
            <button type="button" onClick={() => onChange({})} style={{ marginTop: '10px', fontSize: '12px', background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', textDecoration: 'underline' }}>
              Clear all sensory data
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default SensoryAssessment;
